class Transporter {
  active = String;
  class_name = String;
  countiesAvailabilities = Object;
  countiesPricing = Object;
  deliveryCost = Number;
  deliveryOptionType = String;
  has_vouchers = String;
  id = String;
  lang = String;
  name = String;
  options = Object;
  postalCodesAvailabilities = Array;
  postalCodesPricing = Object;
  send_weight = String;
  slug = String;
  sort = Number;
  transportationCost = Number;
  transporter_id = String;
  useTransporterWidget = Boolean;
}

export default class SmartPointWidget {
  transporter = new Transporter();
  selectedCountry = '';

  constructor (transporter, selectedCountry) {
    this.transporter = transporter
    this.selectedCountry = selectedCountry
  }

  async initializeWidget () {
    switch (this.transporter.class_name) {
      case 'BOXNOW':
        return await this.initializeWidgetBoxNow()
      case 'SKROUTZ':
        return await this.initializeWidgetSkroutz()
      default:
        return Promise.reject(new Error('No widget found.'))
    }
  }

  async initializeWidgetBoxNow () {
    window._bn_map_widget_config = {
      partnerId: 123,
      parentElement: '#boxnowmap',
      type: 'popup',
      autoselect: false,
      autoshow: true,
      afterSelect: (payload) => {
        const ignoredEvents = [
          'vue-devtools-backend',
          'vue-devtools-proxy',
          'vue-devtools-backend-injection'
        ]
        if ('source' in payload && ignoredEvents.includes(payload.source)) {
          return
        }
        if ('boxnowLockerId' in payload) {
          window.Vue.$emit(`${this.transporter.class_name}_AfterSelect`, payload)
          window.Vue.$emit('modal-close', payload)
        }
      }
    }

    const scriptId = 'boxnow-widget-script'
    let script = document.getElementById(scriptId)

    if (script) {
      script.remove()
      script = null
    }

    script = document.createElement('script')
    script.id = scriptId
    script.type = 'text/javascript'

    if (this.selectedCountry === 'GR') {
      script.src = 'https://widget-cdn.boxnow.gr/map-widget/client/v5.js'
    } else if (this.selectedCountry === 'CY') {
      script.src = 'https://widget-cdn.boxnow.cy/map-widget/client/v5.js'
    } else {
      return Promise.reject(new Error('Unsupported country.'))
    }

    script.async = true
    script.defer = true
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(script)

    return new Promise((resolve, reject) => {
      script.onload = () => {
        window.currentCountry = this.selectedCountry
        resolve()
      }
      script.onerror = () => {
        reject(new Error('Error loading script.'))
      }
    })
  }

  async initializeWidgetSkroutz () {
    window._skroutzPointsMapWidgetOptions = {
      language: 'el',
      type: 'iframe',
      parentElement: '#skroutzLockerMap',
      afterSelect: (payload) => {
        const ignoredEvents = [
          'vue-devtools-backend',
          'vue-devtools-proxy',
          'vue-devtools-backend-injection'
        ]
        if ('source' in payload && ignoredEvents.includes(payload.source)) {
          return
        }
        if ('id' in payload) {
          window.Vue.$emit(`${this.transporter.class_name}_AfterSelect`, payload)
          window.Vue.$emit('modal-close', payload)
        }
      }
    }
    this.selectedCountry = 'GR'
    let script = document.getElementById('skroutz-slm-widget-script')

    if (script) {
      script.remove()
      script = null
    }

    script = document.createElement('script')
    script.id = 'skroutz-slm-widget-script'
    script.type = 'text/javascript'
    //@TODO SLM impmenent skroutz widget - get skroutz config mapUrl
    script.src = 'https://staging-sp.skroutzlastmile.gr/setup.js'
    script.async = true
    script.defer = true
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(script)

    return new Promise((resolve, reject) => {
      script.onload = () => {
        resolve()
      }
      script.onerror = () => {
        reject(new Error('Error loading script.'))
      }
    })
  }
}
